<template>
  <div :class="{ dense }" class="promo-banners">
    <div v-if="!dense" class="buttons" />
    <swiper-container ref="swiperElement" :class="{ dense }" class="banners-carousel" v-bind="swiperOptions">
      <swiper-slide v-for="(banner, index) in banners" :key="index" class="promo-banner" @click="handleClick(banner)">
        <img :src="banner.src" alt="banner" />
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<script>
  const ORIENTATION = {
    Portrait: 'portrait',
    Landscape: 'landscape',
  };

  export default {
    name: 'PromoBanners',

    props: {
      banners: {
        type: Array,
        default: () => [],
      },
      dense: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      orientation() {
        return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width
          ? ORIENTATION.Portrait
          : ORIENTATION.Landscape;
      },

      isMobileOrTablet() {
        return this.$vuetify.breakpoint.width < 1024;
      },

      swiperOptions() {
        const isLandscapeOnMobile = this.isMobileOrTablet && this.orientation === ORIENTATION.Landscape;
        const slidesPerView = isLandscapeOnMobile ? 2 : this.isMobileOrTablet ? 1.15 : 3;

        return {
          'slides-per-view': slidesPerView,
          'space-between': 24,
          loop: slidesPerView < 3,
          speed: 600,
          'autoplay-delay': 3000,
          'autoplay-pause-on-mouse-enter': true,
        };
      },
    },

    methods: {
      handleClick(banner) {
        if (banner.to) {
          this.goTo(banner.to);
        } else if (typeof banner.onClick === 'function') {
          banner.onClick();
        }
      },

      goTo(to) {
        if (!to) return;
        this.$router.push(to);
      },

      slidePrev() {
        this.$refs.swiperElement?.swiper.slidePrev();
      },

      slideNext() {
        this.$refs.swiperElement?.swiper.slideNext();
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/scss/mixins';

  .promo-banners {
    position: relative;
    font-weight: 700;
    font-size: 32px;
    color: #fff;

    .buttons {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      margin-bottom: 18px;
      margin-right: 6px;
      height: 36px;

      @media screen and (min-width: 480px) {
        margin-right: 12px;
      }
    }

    .slide-button {
      height: 32px;
      min-width: 40px;
      border-radius: 6px;
      background: rgba(54, 21, 80, 0.5);
      box-shadow: none;
      color: #e7e5ec;
      font-weight: 500;

      @media screen and (min-width: 480px) {
        height: 36px;
        min-width: 48px;
      }
    }

    .banners-carousel {
      @media screen and (min-width: 1024px) {
        &:not(.dense) {
          margin-bottom: 44px;
        }
      }
    }
  }

  .promo-banner {
    display: flex !important;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-radius: 10px;

    img {
      width: 100%;

      @media (min-width: 1024px) {
        width: auto;
      }
    }
  }
</style>
